module.exports = __webpack_public_path__ + "static/media/screenshot_history_2_ru.045d5d11.png";